export enum ScanConfigurationType {
  OVAL = 'OVAL',
  XCCDF = 'XCCDF'
}

export class ScanConfiguration {
  public id?: number;
  public name?: string;
  public definitionId?: string;
  public type?: ScanConfigurationType;
  public s3Key?: string;
  public active?: boolean;

  constructor(obj: ScanConfiguration = {} as ScanConfiguration) {
    this.id = obj.id;
    this.name = obj.name;
    this.definitionId = obj.definitionId;
    this.type = obj.type;
    this.s3Key = obj.s3Key;
    this.active = obj.active;
  }
}